module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/14x11-1a1a2cd127e72843f7153821bafa4564.svg";